import ExtendedRoute from '@/models/ExtendedRoute'

export class ExtendedRouteTransformer {
    transform (data) {
        return new ExtendedRoute(
            data.lat,
            data.lng,
            data.rawLat,
            data.rawLng,
            data.matchDistance,
            data.confidenceValue,
            data.headingMatched,
            data.distanceToRaw,
            data.speedInKph,
            data.speeding,
            data.address,
            data.speedLimitInKph,
            data.UTC,
            data.speedLimit
        )
    }
}
